import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useStyles } from '../../creationsteps/StyleStep';
import omit from 'lodash/omit';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent
} from '@material-ui/core';
import DialogTitleWithCloseButton from '../../../../core/components/DialogTitleWithCloseButton';
import Confirm from '../../../../core/components/forked/layout/Confirm';
import UserAuthorizationDatagrid from '../UserAuthorizationDatagrid';

const useDialogStyles = makeStyles({
  dialogContent: {
    flex: 1,
    display: 'flex',
    padding: '16px'
  }
});
const ManageAuthorizations = ({
  contact,
  isManageModalOpen,
  setIsManageModalOpen,
  groups,
  authorizationsConnectedUser,
  connectedUserProfile,
  authorizationsGridToDeleteRef,
  permissionGroupsUploaded,
  setCurrentAuthorizations,
  currentAuthorizations,
  hasAssignUserAuthorization,
  contactAuthorizationsIds,
  setContactAuthorizationsIds,
  setPermissionGroupsUploaded = () => null,
  permissionToDelete,
  setPermissionToDelete = () => null,
  context,
  ...props
}) => {
  const classes = useStyles();
  const classesDialog = useDialogStyles();
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [permissionsStaging, setPermissionsStaging] = useState([]);

  const handleCloseClick = () => {
    if (permissionsStaging.length === 0) {
      setIsManageModalOpen(false);
    } else {
      setIsConfirmModalOpen(true);
    }
  };

  const handleConfirmDialogClose = () => {
    setPermissionsStaging([]);
    setIsConfirmModalOpen(false);
    setIsManageModalOpen(false);
  };

  function filter(array, permission) {
    return array.filter(
      authorization =>
        authorization.id !==
        `${contact.userId}:${permission.investorId}:${permission.fundId}:${permission.groupId}`
    );
  }

  function omitCheckedProperty(array, permission) {
    return [...array, omit(permission, 'checked')];
  }

  const onSubmit = () => {
    permissionsStaging.forEach(permission => {
      if (permission.checked) {
        setCurrentAuthorizations(prev => omitCheckedProperty(prev, permission));
        setPermissionToDelete(prev => filter(prev, permission));
      } else {
        setCurrentAuthorizations(prev => filter(prev, permission));
        setPermissionGroupsUploaded(prev => filter(prev, permission));
        if (permissionGroupsUploaded.length > 0) {
          if (
            permissionToDelete.filter(element => element.id === permission.id)
              .length === 0
          ) {
            setPermissionToDelete(prev =>
              omitCheckedProperty(prev, permission)
            );
          }
        }
      }
    });
    setPermissionsStaging([]);
    setIsManageModalOpen(false);
  };

  useEffect(() => {
    const contactAuthorizations = currentAuthorizations
      .filter(authorization => {
        return authorization.userId === contact.userId;
      })
      .concat(
        permissionGroupsUploaded.filter(authorization => {
          return authorization.userId === contact.userId;
        })
      );

    setContactAuthorizationsIds(
      contactAuthorizations.map(authorization => {
        return `${authorization.userId}:${authorization.investorId}:${authorization.fundId}:${authorization.groupId}`;
      })
    );
  }, [
    contact.userId,
    currentAuthorizations,
    permissionGroupsUploaded,
    setContactAuthorizationsIds
  ]);

  return (
    <Dialog
      open={isManageModalOpen}
      aria-label={`${contact.firstName} ${contact.lastName} Permission Groups`}
      fullWidth={true}
      maxWidth="md"
      onClose={(_event, reason) => {
        if (reason === 'backdropClick') return null;
        if (reason === 'escapeKeyDown') return handleCloseClick();
      }}
      classes={{
        paperWidthFalse: classes.paperWidthFalse // class name, e.g. `classes-nesting-root-x`
      }}
    >
      <DialogTitleWithCloseButton onClose={handleCloseClick}>
        {`Manage Permissions for ${contact.firstName} ${contact.lastName}`}
      </DialogTitleWithCloseButton>
      <DialogContent className={classesDialog.dialogContent}>
        <UserAuthorizationDatagrid
          {...props}
          authorizations={context.fundInvestors}
          groupBy="investorId"
          groupByLabel="investorName"
          optionText="fundName"
          optionValue="fundId"
          groups={groups}
          groupsFilter="ALL"
          hasWriteAuthorizationPermission={hasAssignUserAuthorization}
          id={contact.userId}
          userType="FUND_ADMIN"
          authorizationsConnectedUser={authorizationsConnectedUser}
          funds={context.fund}
          userProfile={connectedUserProfile}
          createdContactId={contact.userId}
          ids={contactAuthorizationsIds}
          wizardMode={true}
          creation={true}
          userId={contact.userId}
          permissionGroupsUploaded={permissionGroupsUploaded}
          currentAuthorizations={currentAuthorizations}
          columnLabel="Investors"
          setPermissionsStaging={setPermissionsStaging}
          permissionsStaging={permissionsStaging}
          authorizationsGridToDeleteRef={authorizationsGridToDeleteRef}
        />

        <Confirm
          isOpen={isConfirmModalOpen}
          title="Close Window?"
          content={'Your changes for this contact will not be saved.'}
          onConfirm={handleConfirmDialogClose}
          onClose={() => setIsConfirmModalOpen(false)}
          confirm="ra.action.close"
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={onSubmit}
        >
          Done
        </Button>
        <Button
          variant="outlined"
          color="primary"
          size="small"
          onClick={handleCloseClick}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ManageAuthorizations;
